import { helpers, minLength, numeric, required } from "@vuelidate/validators";

const isValidExpiryDateFormat = (value) => {
  return /^\d{2}\/\d{2}$/.test(value); // Checks if format is MM/YY
};

const isExpiryDateInFuture = (value) => {
  const cleanedValue = value.replace(/\//g, "");

  if (cleanedValue.length !== 4) return false;

  const month = parseInt(cleanedValue.substring(0, 2));
  const year = parseInt(cleanedValue.substring(2, 4));
  const currentDate = new Date();
  const currentYear = parseInt(
    currentDate.getFullYear().toString().substring(2)
  );
  const currentMonth = currentDate.getMonth() + 1;

  return (
    month >= 1 &&
    month <= 12 &&
    (year > currentYear || (year === currentYear && month >= currentMonth))
  );
};

const checkId = (value) => {
  let IDnum = String(value);
  if (IDnum.length > 9 || IDnum.length < 5) return false;
  if (!IDnum) return false;
  if (IDnum.length < 9) {
    while (IDnum.length < 9) {
      IDnum = "0" + IDnum;
    }
  }
  let mone = 0,
    incNum;
  for (let i = 0; i < 9; i++) {
    incNum = Number(IDnum.charAt(i));
    incNum *= (i % 2) + 1;
    if (incNum > 9) incNum -= 9;
    mone += incNum;
  }
  if (mone % 10 == 0) return true;
  else return false;
};

const cardNumberValidation = helpers.withMessage(
  "יכול להיות שהחלפתם ספרה? בואו ננסה שוב",
  (value) => {
    if (!value) return false;
    const length = value.replace(/\s+/g, "").length; // Remove spaces and count digits
    return length === 16 || length === 17 || length === 15 || length === 8;
  }
);

const cardValidation = {
  cardNumber: {
    required: helpers.withMessage("צריך את מספר האשראי כדי להמשיך", required),
    cardNumberValidation: helpers.withMessage(
      "יכול להיות שהחלפתם ספרה? בואו ננסה שוב",
      cardNumberValidation
    ),
  },
  cvv: {
    required: helpers.withMessage(
      "אנחנו צריכים גם את שלש הספרות בגב הכרטיס",
      required
    ),
    numeric,
    minLength: helpers.withMessage(
      "חסר כאן משהו. צריך שלוש ספרות בגב הכרטיס",
      minLength(3)
    ),
  },
  expirationDate: {
    required: helpers.withMessage("מה תוקף הכרטיס?", required),
    isValidExpiryDateFormat: helpers.withMessage(
      "זה צריך להראות ככה: MM/YY שתי ספרות לחודש ושתי ספרות לשנה. בדיוק כמו שכתוב לכם על הכרטיס",
      isValidExpiryDateFormat
    ),
    isExpiryDateInFuture: helpers.withMessage(
      "התוקף שכתבתם כבר פג. צריך להשתמש בכרטיס בתוקף.",
      isExpiryDateInFuture
    ),
  },
  idNumber: {
    required: helpers.withMessage(
      "כדי להמשיך צריך לכתוב כאן מספר זהות",
      required
    ),
    checkId: helpers.withMessage(
      "יש כאן טעות. צריך לבדוק ולתקן את מספר הזהות",
      checkId
    ),
  },
};

export { cardValidation };
